const baseURL = `https://server.collectanea.co`

export default baseURL